import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const Cat = () => {

  const { id } = useParams();
  console.log(id);

  const [articles, setArticles] = useState({
    articles_name: "",
    articles_description: "",
    image: ""
  })
  const { articles_name, articles_description, image } = articles;
  useEffect(() => {
    loadUsers();
  }, [])

  const loadUsers = async () => {

    // console.log('AA'+id)
    const result = await axios.get("https://acesoftech.co.in/tanzil/ecomAPI/tanzil_blog/articles/getSingleBlog.php?id=" + id);
    setArticles(result.data);
    //console.log(result);
  }



// COMMENTS INSERT
  const [comments, setComments] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  //  articles_id: ""

})
const {
    name,
    email,
    phone,
    message
   // articles_id
} = comments;
console.log(comments);

const handleChange = (e) => {
  const vals = { ...comments, [e.target.name]: e.target.value };
  // let finalvals = { articles_id: 1, ...vals };
  // console.log()
  setComments(vals);
}

const submitForm = async (e) => {
    e.preventDefault();

    let finalcomments = { articles_id: id, ...comments };

    console.log(finalcomments);


    await axios.post("https://acesoftech.co.in/tanzil/ecomAPI/tanzil_blog/comments/comments_insert.php", finalcomments, { mode: 'cors' })
        .then((result) => {
            console.log(result);
            if (result.data.status == 'valid') {
                // history(`/list-student`);
            } else {
                alert("There is problem in adding, please try again");
            }
        });
}


  return (
    <div>
      <div class="card card-horizontal">
        <div class="card-body">
          <div class="card-horizontal">
            <img src={'https://acesoftech.co.in/tanzil/ecomAPI/tanzil_blog/images/' + articles.image} />
          </div>

          <div class="card-horizontal-left">
            <h3 class="card-title">{articles.articles_name}</h3>
            <div class="card-excerpt">
              <p>{articles.articles_description}</p>
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={e => submitForm(e)}>
      <div class="row">
      <div class="col-12 col-lg-12"><h3 class="text-center"><u>Comments</u></h3></div>
      </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <p>
              <label>Your Name</label><br />
              <input type="hidden" name="name" onChange={e => handleChange(e)} id="sendername" class="form-control" required="required" maxlength="50" />
                <input type="text" name="name" onChange={e => handleChange(e)} id="sendername" class="form-control" required="required" maxlength="50" />
                </p>
                <p>
                  <label>Your Email</label><br/>
                    <input type="email" name="email" onChange={e => handleChange(e)} id="senderemail" class="form-control" required="required" maxlength="50"/>
                    </p>
                    <p>
                      <label>Phone Number</label><br/>
                        <input type="text" name="phone" onChange={e => handleChange(e)} id="senderphone" class="form-control" maxlength="50"/>
                        {/* <input type="hidden" name="status" onChange={e => handleChange(e)} value="0" id="senderphone" class="form-control" maxlength="50"/> */}
                        </p>
                      </div>
                      <div class="col-12 col-lg-6">
                        <p>
                          <label>Your Message</label><br/>
                            <textarea name="message" onChange={e => handleChange(e)} id="sendermessage" required="required" class="form-control form-fixed-height"></textarea>
                        </p>
                        <button id="sendbutton" type="submit" class="btn btn-lg w-100">Send Message</button>
                      </div>
                    </div>
                  </form>
                </div>
                )
}

                export default Cat